import { IResult } from '@sv-support-sdk/shared-types/src/common/search';
import { routes } from '../routing';

export const formResultLink = (result: IResult) => {
  if (result.type === 'release_note') {
    return `${routes.releaseNotes}/${result.slug}`;
  }

  if (result.type === 'faq_topic') {
    return `${routes.faq}/${result.categorySlug}/${result.slug}`;
  }

  if (result.type === 'topic') {
    return `${routes.articles}/${result.categorySlug}/${result.slug}`;
  }

  return;
};
